package com.appsyde.shared.presentation.screen.screen

import androidx.compose.runtime.Composable
import com.appsyde.shared.app.navigation.AppPaths
import com.appsyde.shared.presentation.style.AppStylesLanding
import org.jetbrains.compose.web.dom.*

/**
 * Layout commun pour les pages légales (Privacy, Terms, Legal) : nav, contenu, footer.
 */
@Composable
fun LegalPageLayout(
    title: String,
    content: @Composable () -> Unit
) {
    Div({ classes(AppStylesLanding.page) }) {
        Nav({ classes(AppStylesLanding.topNav) }) {
            Div({ classes(AppStylesLanding.container, AppStylesLanding.navInner) }) {
                A("/", { classes(AppStylesLanding.brand) }) {
                    Img("/appsydeIcon.png", attrs = {
                        classes(AppStylesLanding.brandIcon)
                        attr("alt", "AppSyde")
                    })
                    Span { Text("AppSyde") }
                }
                Div({ classes(AppStylesLanding.navLinks) }) {
                    A(AppPaths.PRIVACY, { classes(AppStylesLanding.navLink) }) { Text("Privacy") }
                    A(AppPaths.TERMS, { classes(AppStylesLanding.navLink) }) { Text("Terms") }
                    A(AppPaths.LEGAL, { classes(AppStylesLanding.navLink) }) { Text("Legal") }
                }
            }
        }

        Section({ classes(AppStylesLanding.section) }) {
            Div({ classes(AppStylesLanding.container) }) {
                Div({ classes(AppStylesLanding.sectionHeader) }) {
                    H1({ classes(AppStylesLanding.h2) }) { Text(title) }
                }
                Div({ classes(AppStylesLanding.legalContent) }) { content() }
            }
        }

        Footer({ classes(AppStylesLanding.footer) }) {
            Div({ classes(AppStylesLanding.container) }) {
                Div({ classes(AppStylesLanding.footerInner) }) {
                    Div({ classes(AppStylesLanding.footerBrandRow) }) {
                        Img("/appsydeIcon.png", attrs = {
                            classes(AppStylesLanding.brandIcon)
                            attr("alt", "AppSyde")
                        })
                        Span { Text("© ${js("new Date().getFullYear()") as Int} AppSyde") }
                    }
                    Div({ classes(AppStylesLanding.footerLinks) }) {
                        A(AppPaths.PRIVACY, { classes(AppStylesLanding.navLink) }) { Text("Privacy") }
                        A(AppPaths.TERMS, { classes(AppStylesLanding.navLink) }) { Text("Terms") }
                        A(AppPaths.LEGAL, { classes(AppStylesLanding.navLink) }) { Text("Legal") }
                        A("mailto:appsyde.tb.help@gmail.com", { classes(AppStylesLanding.navLink) }) { Text("Contact") }
                    }
                }
                Div({ classes(AppStylesLanding.footerDisclaimer) }) {
                    Text("AppSyde — support par email, cohérent, sous contrôle.")
                }
            }
        }
    }
}
